import makeAction from "./../../libs/actions";

export const fetchAlbumsAction = makeAction("tracks/FETCH_ALBUMS");
export const fetchAlbumBySlugAction = makeAction("tracks/FETCH_ALBUM_BY_SLUG");
